import { format } from 'date-fns'

export default function Datetime (props) {
  if (!props.date) {
    return null
  }

  const date = new Date(props.date)
  const formatStr = props.format || 'Pp'
  const formatted = format(date, formatStr)

  return <span>{formatted}</span>
}
